export default {
    name: 'lv',
    messages: {
        _default: function (e) {
            return "Lauka " + e.toLowerCase() + " vērtība nav derīga."
        }, after: function (e, n) {
            var t = n[0];
            return "Lauka " + e.toLowerCase() + " vērtībai jābūt lielākai par " + (n[1] ? "vai vienādai ar " : "") + t + "."
        }, alpha_dash: function (e) {
            return "Laukā " + e.toLowerCase() + " jāizmanto tikai alfabēta burit, cipari, domuzīmes un apakšsvītras."
        }, alpha_num: function (e) {
            return "Laukā " + e.toLowerCase() + " jāizmanto itkai alfabēta burti un cipari."
        }, alpha_spaces: function (e) {
            return "Laukā " + e.toLowerCase() + " jāizmanto tikai alfabēta burti un atstarpes."
        }, alpha: function (e) {
            return "Laukā " + e.toLowerCase() + " jāizmanto tikai alfabēta burti."
        }, before: function (e, n) {
            var t = n[0];
            return "Lauka " + e.toLowerCase() + " vērtībai jābūt mazākai par " + (n[1] ? "vai vienāda ar " : "") + t + "."
        }, between: function (e, n) {
            return "Laukā " + e.toLowerCase() + " jānorāda vērtība starp " + n[0] + " un " + n[1] + "."
        }, confirmed: function (e) {
            return "Lauka " + e.toLowerCase() + " vērtībai jāsakrīt ar apstiprināto vērtību."
        }, credit_card: function (e) {
            return "Laukā " + e.toLowerCase() + " jānorāda derīgs kredītkartes numurs."
        }, date_between: function (e, n) {
            return "Laukā " + e.toLowerCase() + " jānorāda datums starp " + n[0] + " un " + n[1] + "."
        }, date_format: function (e, n) {
            return "Laukā " + e.toLowerCase() + " jānorāda datums atbilstoši " + n[0] + " formātam."
        }, decimal: function (e, n) {
            void 0 === n && (n = []);
            var t = n[0];
            return void 0 === t && (t = "*"), "Laukā " + e.toLowerCase() + " jānorāda daļskaitlis ar " + (t && "*" !== t ? t : "") + " cipariem aiz komata."
        }, digits: function (e, n) {
            return "Laukā " + e.toLowerCase() + " jānorāda " + n[0] + " ciparu garš skaitlis."
        }, dimensions: function (e, n) {
            return "Laukā " + e.toLowerCase() + " pievienotajai bildei jāatbilst izmēram " + n[0] + "px x " + n[1] + "px."
        }, email: function (e) {
            return "Laukā " + e.toLowerCase() + " jānorāda derīga e-pasta adrese."
        }, ext: function (e) {
            return "Laukā " + e.toLowerCase() + " drīkst pievienot tikai derīgus failus."
        }, image: function (e) {
            return "Laukā " + e.toLowerCase() + " drīkst pievienot tikai bildes."
        }, in: function (e) {
            return "Laukā " + e.toLowerCase() + " jānorāda tikai atļautās vērtības."
        }, integer: function (e) {
            return "Laukā " + e.toLowerCase() + " jānorāda pilns skaitlis."
        }, ip: function (e) {
            return "Laukā " + e.toLowerCase() + " jānorāda derīga IP adrese."
        }, length: function (e, n) {
            var t = n[0], i = n[1];
            return i ? "Lauka " + e.toLowerCase() + " vērtības garumam jābūt starp " + t + " un " + i + "." : "Lauka " + e.toLowerCase() + " vērtības garumam jābūt " + t + "."
        }, max: function (e, n) {
            return "Lauks " + e.toLowerCase() + " nedrīkst būt garākas par " + n[0] + " simboliem."
        }, max_value: function (e, n) {
            return "Laukam " + e.toLowerCase() + " jābūt mazākam par " + n[0] + "."
        }, mimes: function (e) {
            return "Laukā " + e.toLowerCase() + " jāpievieno tikai atļauts formāts."
        }, min: function (e, n) {
            return "Laukam " + e.toLowerCase() + " jāsatur vismaz " + n[0] + " simboli."
        }, min_value: function (e, n) {
            return "Laukam " + e.toLowerCase() + " jābūt lielākam par " + n[0] + "."
        }, not_in: function (e) {
            return "Laukā " + e.toLowerCase() + " jānorāda tikai atļauta vērtība."
        }, numeric: function (e) {
            return "Laukā " + e.toLowerCase() + " jānorāda tikai skaitļi."
        }, regex: function (e) {
            return "Laukā " + e.toLowerCase() + " field format is invalid."
        }, required: function (e) {
            return "Obligāti jāaizpilda " + e.toLowerCase() + "."
        }, size: function (e, n) {
            return "Laukā " + e.toLowerCase() + " pievienotajam failam jābūt mazākam par  " + function (e) {
                var n = 0 == (e = 1024 * Number(e)) ? 0 : Math.floor(Math.log(e) / Math.log(1024));
                return 1 * (e / Math.pow(1024, n)).toFixed(2) + " " + ["Byte", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][n]
            }(n[0]) + "."
        }, url: function (e) {
            return "Laukā " + e.toLowerCase() + " jānorāda derīga Interneta adrese."
        }
    },
    attributes: {
        'first_name': 'Vārds',
        'last_name': 'Uzvārds',
        'email': 'E-pasts',
        'topic': 'Tēma',
        'message': 'Ziņojums',
        'password': 'Parole',
        'remember': 'Atcerēties',
        'password_confirmed': 'Paroles apstiprinājums',
        'title': 'Nosaukums',
        'uri': 'Interneta resursa saite',
        'description': 'Apraksts',
        'school_id': 'Skola',
        'school': 'Skola',
        'avatar': 'Avatara',
        'avatar_id': 'Avatara',
        'classCategory': 'Klases kategorija',
        'themeCategory': 'Tēmas kategorija',
        'typeCategory': 'Tipa kategorija',
        'signature_type': 'Ievietot kā',
        'pseudonym': 'Pseidonīms',
        'note': 'Piezīmes'
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/lang/lv/validatoin.js